import '@fontsource/noto-sans';
import '@fontsource/noto-sans/200.css';
import '@fontsource/noto-sans/400.css';
import '@fontsource/noto-sans/700.css';
import './src/styles/destyle.css';
import './src/styles/global.scss';
import './src/styles/variables.scss';

import React from 'react';

import NewSiteLink from './src/components/NewSiteLink';

export const wrapPageElement = () => <NewSiteLink />;
